import { captureException } from './sentry';

let installed = false;

/** Install once per SPA: window error + unhandledrejection → Sentry/console. */
export function installGlobalErrorHandlers(): void {
  if (typeof window === 'undefined' || installed) return;
  installed = true;

  window.addEventListener('error', (event) => {
    captureException(event.error ?? event.message, {
      source: 'window.error',
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    captureException(event.reason, {
      source: 'unhandledrejection',
    });
  });
}
